import React, { useState } from "react"
import OtpInputBox from "react-otp-input"

const OtpInput = ({ numOfOTP = 4, onChange = () => {}, value = "" }) => {
  return (
    <OtpInputBox
      value={value}
      onChange={onChange}
      numInputs={numOfOTP}
      inputType="tel"
      renderInput={(props) => (
          <input
            {...props}
            style={inputStyle}
          />
      )}
    />
  )
}
const inputStyle = {
  display: "flex",
  justifyContent:'center',
  fontFamily: "Apparat",
  fontSize: "16px",
  width: "68px",
  height: "68px",
  background: "rgba(66, 73, 82, 0.03)",
  border: "1px solid rgba(66, 73, 82, 0.2)",
  boxSizing: "border-box",
  boxShadow: "0px 9px 25px rgba(32, 41, 76, 0.05)",
  borderRadius: "10px",
  paddingLeft:30,
  marginRight: "20px",
  
}

export default OtpInput
